import { CommonModule, DatePipe } from '@angular/common';
import { UtcDatePipe } from '../../../core/pipes/utc-date.pipe';
import { Component, Input, ViewChild } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ExecutorModalComponent } from '../../../components/executor-modal/executor-modal.component';
import { faBan, faChevronLeft, faCircle, faPenLine, faPlay, faChevronDown, faGear, faTriangleExclamation } from '@fortawesome/pro-solid-svg-icons';
import { faUser, faCommentPlus, faCommentExclamation, faXmark } from '@fortawesome/pro-light-svg-icons';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { TableComponent } from '../../../components/table/table.component';
import { DeclarationsService } from '../../../core/services/declarations/declarations.service';
import { CommentModalComponent } from '../../../components/comment-modal/comment-modal.component';
import { ContractObservationsService } from '../../../core/services/contract-observations/contract-observations.service';
import { AuthService } from '../../../core/services/auth.service';
import { TypeChangeEnum } from '../../../core/enums/type-change.enum';
import { DeclarationPhasesComponent } from '../../../components/declaration-phases/declaration-phases.component';
import { FiltersService } from '../../../core/services/declarations/filters.service';
import { DropdownModule } from 'primeng/dropdown';
import { StatusDeclarationEnum } from '../../../core/enums/status-declaration.enum';
import { MenuModule } from 'primeng/menu';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-multiple-gestion',
  standalone: true,
  imports: [FontAwesomeModule, CommonModule, RouterModule, FormsModule, ReactiveFormsModule, ExecutorModalComponent, TableComponent, CommentModalComponent, DeclarationPhasesComponent, DropdownModule, MenuModule, ButtonModule, InputTextareaModule, DatePipe, UtcDatePipe],
  templateUrl: './multiple-gestion.component.html',
  styleUrl: './multiple-gestion.component.scss'
})
export class MultipleGestionComponent {
  isSending = false;

  @ViewChild('modal') modal: ExecutorModalComponent;
  @ViewChild('commentModal') commentModal: CommentModalComponent;

  data: any;
  faBan = faBan;
  faPenLine = faPenLine;
  faPlay = faPlay;
  faCircle = faCircle;
  faChevronLeft = faChevronLeft;
  faUser = faUser;
  faChevronDown = faChevronDown;
  faGear = faGear;
  faCommentPlus = faCommentPlus;
  faCommentExclamation = faCommentExclamation;
  faXmark = faXmark;
  faTriangleExclamation = faTriangleExclamation;
  actionMenuItems: any[] = [];
  currentUserId: number = null;
  currentUserDepartment: string = null;
  multipleAvisos: any[] = [];
  hasAvisos: boolean = false;

  avisoForm = new FormGroup({
    comment: new FormControl('', Validators.required),
  });

  hoveringExecutor = null;
  hoverTask = null;
  hoverPhase = null;

  decsTable = {
    headers: [{
      name: 'Modelo',
      key: 'model'
    },
    {
      name: 'Cliente',
      key: 'clientName'
    },
    {
      name: 'Tipo presentación',
      key: 'presentationType'
    },
    {
      name: 'Fase',
      key: 'tasks'
    },
    {
      name: 'Responsable',
      key: 'responsible'
    },
    {
      name: 'Cuenta bancaria',
      key: 'bankAccount'
    }],
    data: undefined,
    disableLink: true,
    historic: false
  };
  comments = [];

  declaration: any;

  configModal: any = undefined;
  showModal: boolean = false;

  selectedTask = null;

  user = undefined;

  commentForm = new FormGroup({
    comment: new FormControl('', Validators.required),
  });

  configCommentModal: any = undefined;
  showCommentModal: boolean = false;
  showAvisosModal: boolean = false;

  decFinished = false;

  phases = [];
  changes = [];

  allExpanded = true;

  responsibles;
  isDynamic = false;


  constructor(
    private route: ActivatedRoute,
    private declarationService: DeclarationsService,
    private router: Router,
    private filtersService: FiltersService,
    private contractObservationsService: ContractObservationsService,
    private authService: AuthService
  ) { }


  async ngOnInit() {
    this.user = this.authService.getUser()?.user;
    this.currentUserId = this.authService.getUserId();
    const currentUser = this.authService.getUser();
    this.currentUserDepartment = currentUser?.user?.department;
    let ids = this.route.snapshot.queryParamMap.get('ids').split(',').map(id => Number(id));
    await this.getData(ids);
    this.responsibles = await this.filtersService.getUsers();
    this.disableTasks(this.data.declarations[0].presentationType, true);
    await this.disableTasksOnTaskChange();
    this.buildActionMenu();
    await this.checkHasAvisos();
  }
  async getData(ids) {
    this.data = await this.declarationService.getDeclarationsInMass(ids);
    this.isDynamic = this.data.declarations[0].model.isDynamic ? true : false;
    this.decsTable = { ...this.decsTable, headers: this.decsTable.headers, data: this.data, historic: false, disableLink: true };
    this.data.phases.forEach(p => {
      p.show = true;
      p.tasks.forEach(t => {
        if (t.type === 'CHECK' && (t.value === null || t.value === "false")) {
          t.value = false;
        }
        if (t.type === 'CHECK' && t.value === "true") {
          t.value = true;
        }
        t.initialValue = t.value;
      });
    });
  }

  async commentAdd(comment?): Promise<void> {
    let observations = [];
    for (let declaration of this.data.declarations) {
      let observation = {
        declaration: declaration.id,
        comment: comment ? comment : this.commentForm.value.comment
      }
      observations.push(observation);
    }
    await this.declarationService.createObservationInMass(observations);
    this.commentForm.reset();
  }

  async avisoAdd(comment: string): Promise<void> {
    if (!comment || !this.currentUserId) return;

    const progressDeclarations = this.data.declarations.filter(d => d.status === 'PROGRESS');
    if (progressDeclarations.length === 0) {
      console.warn('No hay declaraciones en PROGRESS para añadir avisos');
      return;
    }

    try {
      for (const declaration of progressDeclarations) {
        if (!declaration.contract?.id) continue;
        await this.contractObservationsService.createObservation({
          contractId: declaration.contract.id,
          declarationId: declaration.id,
          userId: this.currentUserId,
          comment,
          isNotification: true,
        });
      }
      this.avisoForm.reset();
      await this.loadMultipleAvisos();
      this.hasAvisos = true;
    } catch (error) {
      console.error('Error adding avisos to declarations:', error);
    }
  }

  showAllFases() {
    this.allExpanded = !this.allExpanded;
    this.data.phases.forEach(p => {
      p.show = this.allExpanded;
    });
  }

  handleChanges(changes) {
    this.changes = changes;
  }

  /** Cuenta bancaria solo si todas las declaraciones seleccionadas la tienen; si falta alguna, '' (bloquea la tarea). */
  get commonBankAccount(): string {
    const accounts: string[] = (this.data?.declarations ?? []).map(d => d.bankAccount?.trim());
    return accounts.length > 0 && accounts.every(Boolean) ? accounts[0] : '';
  }

  async sendChanges() {
    if (this.isSending) return;
    this.isSending = true;
    try {
      await this.declarationService.massTaskStatusUpdate(this.changes);
      await this.router.navigate(['/declarations']);
    } finally {
      this.isSending = false;
    }
  }

  async finishDeclarations() {
    if (this.isSending) return;
    // Solo las que están en curso: una "No procede" o ya finalizada no debe pasar a FINISHED.
    const ids = this.data.declarations.filter(d => d.status === 'PROGRESS').map(d => d.id);
    this.isSending = true;
    try {
      await this.declarationService.massTaskStatusUpdate(this.changes);
      if (ids.length) {
        await this.declarationService.changeStatusDeclarationInMass(ids, 'FINISHED');
      }
      await this.router.navigate(['/declarations']);
    } finally {
      this.isSending = false;
    }
  }

  allPhasesSelected() {
    return this.data.phases.every(phase =>
      phase.tasks.filter(task => !task.isDisabled).every(task => task.value === true)
    );
  }

  async setResponsible(event) {
    const id = event.value;
    this.data.forEach(d => {
      this.changes.push(d.id, { type: TypeChangeEnum.Responsible, change: id })
    });
  }

  async disableTasks(presentation, isInitial = false) {
    for (let phase of this.data.phases) {
      for (let task of phase.tasks) {
        if (task.isDisabledByTypePresentation) {
          if (task.isDisabledByTypePresentation.includes(presentation)) {
            if (task.isDisabled !== true) {
              task.isDisabled = true;
              if (!isInitial) {
                await this.declarationService.disableTaskUpdateInMass(task);
              }
            }
          }
          else {
            if (task.isDisabled !== false) {
              task.isDisabled = false;
              if (!isInitial) {
                await this.declarationService.disableTaskUpdateInMass(task);
              }
            }
          }
        }
      }
    }
  }

  async disableTasksOnTaskChange() {
    for (let phase of this.data.phases) {
      for (let task of phase.tasks) {
        if (task.disabledIfTaskDisabled) {
          let disableTask = this.data.phases[parseInt(task.disabledIfTaskDisabled.split('.')[0]) - 1].tasks.find(t =>
            task.disabledIfTaskDisabled === t.orderId
          );
          if (disableTask?.isDisabled) {
            if (task.isDisabled !== true) {
              task.isDisabled = true;
              await this.declarationService.disableTaskUpdate(task);
            }
          } else {
            if (task.isDisabled !== false) {
              task.isDisabled = false;
              await this.declarationService.disableTaskUpdate(task);
            }
          }
        }
        if (task.isDisabledByTask) {
          let disableTask = this.data.phases[parseInt(task.isDisabledByTask.split('.')[0]) - 1].tasks.find(t =>
            String(task.isDisabledByTask) === String(t.orderId)
          );
          if (disableTask.value && !disableTask.isDisabled) {
            if (task.disabledOnValues.includes(disableTask.value)) {
              if (task.isDisabled !== true) {
                task.isDisabled = true;
                await this.declarationService.disableTaskUpdate(task);
              }
            }
            else {
              if (task.isDisabled !== false) {
                task.isDisabled = false;
                await this.declarationService.disableTaskUpdate(task);
              }
            }
          } else {
            if (task.isDisabled !== true) {
              task.isDisabled = true;
              await this.declarationService.disableTaskUpdate(task);
            }
          }
        }
      }
    }


  }

  openCommentModal() {
    this.showCommentModal = true;
  }

  closeCommentModal() {
    this.showCommentModal = false;
  }

  async openAvisosModal() {
    await this.loadMultipleAvisos();
    this.showAvisosModal = true;
  }

  closeAvisosModal() {
    this.showAvisosModal = false;
    this.multipleAvisos = [];
    this.avisoForm.reset();
  }

  async checkHasAvisos() {
    for (const declaration of this.data.declarations) {
      try {
        const avisos = await this.contractObservationsService.getObservationsByDeclaration(declaration.id);
        if ((avisos || []).length > 0) {
          this.hasAvisos = true;
          return;
        }
      } catch (error) {
        console.error(`Error checking avisos for declaration ${declaration.id}:`, error);
      }
    }
    this.hasAvisos = false;
  }

  async loadMultipleAvisos() {
    this.multipleAvisos = [];
    const allAvisos = new Map<string, any>();

    for (const declaration of this.data.declarations) {
      try {
        const avisos = await this.contractObservationsService.getObservationsByDeclaration(declaration.id);
        (avisos || []).forEach(aviso => {
          if (!allAvisos.has(aviso.comment)) {
            allAvisos.set(aviso.comment, aviso);
          }
        });
      } catch (error) {
        console.error(`Error loading avisos for declaration ${declaration.id}:`, error);
      }
    }

    this.multipleAvisos = Array.from(allAvisos.values())
      .sort((a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime());
  }

  async setToNoProceed(comment) {
    if (this.isSending) return;
    this.isSending = true;
    try {
      await this.commentAdd(comment);
      await Promise.all(this.data.declarations.map(d =>
        this.declarationService.editDeclaration(d.id, { type: TypeChangeEnum.Status, change: StatusDeclarationEnum.NotApplicable })));
      await this.router.navigate(['/declarations']);
    } finally {
      this.isSending = false;
    }
  }

  buildActionMenu() {
    // Verificar si todas las declaraciones están en PROGRESS
    const allInProgress = this.data?.declarations?.every(d => d.status === 'PROGRESS') ?? false;

    this.actionMenuItems = [
      // Solo mostrar "Añadir aviso" si todas las declaraciones están en PROGRESS
      ...(allInProgress ? [{
        label: 'Añadir aviso',
        icon: this.faCommentExclamation,
        command: () => {
          this.openAvisosModal();
        }
      }] : []),
      {
        label: 'No procede',
        icon: this.faBan,
        command: () => {
          this.openCommentModal();
        }
      }
    ];
  }


  allDeclarationsInProgress(): boolean {
    return this.data?.declarations?.every(d => d.status === 'PROGRESS') ?? false;
  }

}
